module.exports = __webpack_public_path__ + "static/img/6.ad1bb32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/eng/6.png
// module id = H81W
// module chunks = 0